export default {
  no: {
    'hello.world': 'Hei Verden',
    'profile.personalInfo.heading': 'Personopplysninger',
    'header.heading': 'Sertifikatsøknader',
    'pick.prosecutor': 'Velg aktør',
    'pick.prosecutor.description': 'Du får opp denne siden fordi du har flere du kan rapportere på vegne av. Velg i listen nedenfor hvem det er du ønsker å representere.',
    'back.button': 'Tilbake',
    'contact.info': 'Kontaktinformasjon',
    'hotline': 'Vakttelefon (hele døgnet): ',
    'hotline.number': '52 74 50 00',
    'nis.nor': 'NIS/NOR: ',
    'nis.nor.number': '52 74 50 00',
    'fax': 'Telefaks: ',
    'fax.number': '52 74 50 01',
    'hotline.sr': 'Vakttelefon Skipsregistrene (kl 07-24): ',
    'hotline.sr.number': '930 84 263',
    'logo.alt.text': 'Sjøfartsdirektoratet logo'
  },
  en: {
    'hello.world': 'Hello world',
    'profile.personalInfo.heading': 'Personal information',
    'header.heading': 'Certificate applications',
    'pick.prosecutor': 'Pick prosecutor',
    'pick.prosecutor.description': 'You are viewing this page because there are several people you can represent. In the list below, select who you want to represent.',
    'back.button': 'Go back',
    'contact.info': 'Contact info',
    'hotline': 'Hotline (round the clock): ',
    'hotline.number': '52 74 50 00',
    'nis.nor': 'NIS/NOR: ',
    'nis.nor.number': '52 74 50 00',
    'fax': 'Fax: ',
    'fax.number': '52 74 50 01',
    'hotline.sr': 'Hotline The ship registers (kl 07-24): ',
    'hotline.sr.number': '930 84 263',
    'logo.alt.text': 'Norwegian Maritime Authority logo'
  }
};
